import React, { PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Base from '@jimpick/spectacle/src/base';
import Radium from 'radium';
import ButtonBar from './buttonBar';
import PresentNotes from './present';
import Scores from './scores';
import Fun from './fun';
import Overview from './overview';
import Exit from './exit';
import './teacherRemote.scss';

@Radium
class Presenter extends Base {

  static propTypes = {
    lastSlide: PropTypes.number,
    slides: PropTypes.array.isRequired,
    slide: PropTypes.number.isRequired,
    TOC: PropTypes.array.isRequired,
    prevSlide: PropTypes.func.isRequired,
    nextSlide: PropTypes.func.isRequired,
    getHash: PropTypes.func.isRequired
  }

  static contextTypes = {
    session: PropTypes.object.isRequired
  }

  render () {
    const { session } = this.context;
    const { mode } = session;

    return (
      <div className="teacher-remote">
        <div className="teacher-remote-panel panel panel-primary">
          <ReactCSSTransitionGroup
              className="teacher-remote-content-transition-group"
              transitionName="teacher-remote-switch"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={300}>
            {!mode ? <PresentNotes key="present" {...this.props} /> : null}
            {mode === 'scores' ? <Scores key="scores" /> : null}
            { mode && (mode.replace(/\/.*$/, '') === 'extras')
            ? <Fun key="extras" />
            : null
            }
            {mode === 'modules' ? <Overview key="modules" /> : null}
            {mode === 'exit' ? <Exit key="exit" /> : null}
          </ReactCSSTransitionGroup>
          <ButtonBar />
        </div>
      </div>
    );
  }
}

export default Presenter;



// WEBPACK FOOTER //
// ./src/views/hudTeacherRemote/teacherRemote.jsx